module.exports = __webpack_public_path__ + "static/media/altscore_response_ec.637b3b17.pdf";